import "bootstrap/dist/css/bootstrap.css";

import * as React from "react";
import ReactDOM from "react-dom/client";
// import { createBrowserHistory } from "history";
import App from "./Core/App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

// Create browser history to use in the Redux store
// const baseUrl = document
//   .getElementsByTagName("base")[0]
//   .getAttribute("href") as string;

// const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.//
//const store = configureStore(history);

/*ReactDOM.render(<App />, document.getElementById("root"));*/

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(<App />);

// registerServiceWorker();
unregisterServiceWorker();
